import React from "react";
//import FC from "react";

const Alphabet = (props: any) => {
  let id = Date.now() + "-" + Math.random();
  return (
    <svg
      style={{ marginTop: "20px", marginBottom: "20px" }}
      width="140"
      height="92"
      viewBox="0 0 54 62"
      fill="none"
    >
      <linearGradient id={id} x1="0.5" y1="1" x2="0.5" y2="0">
        <stop offset="0%" stop-opacity="1" stop-color="#6284D9" />
        <stop
          offset={props?.value}
          stop-opacity="1"
          stop-color="#6284D9"
        >
          <animate
            attributeName="offset"
            values="0;1;0"
            repeatCount="2"
            dur="5s"
            begin="0s"
          />
        </stop>
        <stop
          offset={props?.value}
          stop-opacity="0.5"
          stop-color="#F4F5F7"
        >
          <animate
            attributeName="offset"
            values="0;1;0"
            repeatCount="2"
            dur="5s"
            begin="0s"
          />
        </stop>
        <stop offset="100%" stop-opacity="0.5" stop-color="#F4F5F7" />
      </linearGradient>

      <path
        d="M39.7227 61.3573L36.2647 47.614H17.024L13.566 61.3573H0L18.886 0H34.7573L53.5547 61.3573H39.7227ZM19.5067 37.9493H33.782L26.6 9.66467L19.5067 37.9493Z"
        // fill="url(#homeSvg)"
        fill={`url(#${id})`}
        stroke="crimson"
        strokeWidth="0"
      />
    </svg>
  );
};

export default Alphabet;
